import React from 'react';
import { sizeValues } from '@sharefiledev/antd-config';
import { getSignatureRequestDrawerSteps } from '@sharefiledev/esign-pilet-sdk';
import { PencilSquare } from '@sharefiledev/icons';
import { StepProps } from 'antd';
import { t } from '../../utils';

const ICON_SIZE = sizeValues.MS;
const THREE_STEPS = 3;

export const getStepsConfig = (numberOfSteps: number, isMobile = false): StepProps[] => {
	const steps = getSignatureRequestDrawerSteps() as StepProps[];

	if (numberOfSteps === THREE_STEPS) {
		steps.splice(0, 0, {
			title: !isMobile ? t('SendSignatureRequest.populateFields') : undefined,
			status: 'process',
			icon: (
				<PencilSquare size={ICON_SIZE} data-testid="pencil-square-icon" />
			) as React.ReactNode,
		});
	}

	// Map steps to include/exclude titles based on screen size.
	// Currently Esign SDK does not hide the title for Mobile screen.
	// We can remove this later when ESign handles the responsiveness.
	// Alternatively we can create common Step component in Document Builder SDK to solve this issue.
	return steps.map(step => ({
		...step,
		title: !isMobile ? step.title : undefined, // Hide step titles and show only the icons on mobile for better visibility
	}));
};
